import { Fragment } from 'react';

interface Step {
  label: string;
  done?: boolean;
  current?: boolean;
}

const STEPS: Step[] = [
  { label: 'Sign in', done: true },
  { label: 'Access review', current: true },
  { label: 'Workspace ready' },
];

const MotifSteps = () => (
  <div className="flex items-center w-[420px] max-w-full">
    {STEPS.map((step, i) => (
      <Fragment key={step.label}>
        <div className="flex flex-col items-center gap-2.5 min-w-[100px]">
          <div
            className={`w-[34px] h-[34px] rounded-full inline-flex items-center justify-center text-[13px] font-bold border-2 ${
              step.done
                ? 'bg-brand-500 border-brand-500 text-white'
                : step.current
                ? 'bg-white border-brand-500 shadow-[0_0_0_6px_rgba(124,108,246,0.16)]'
                : 'bg-white border-gray-200 text-gray-500'
            }`}>
            {step.done ? (
              '✓'
            ) : step.current ? (
              <span className="w-2.5 h-2.5 rounded-full bg-brand-500 animate-es-pulse" />
            ) : (
              i + 1
            )}
          </div>
          <div
            className={`text-xs whitespace-nowrap ${
              step.current ? 'font-semibold text-gray-700' : 'font-medium text-gray-500'
            }`}>
            {step.label}
          </div>
        </div>

        {i < STEPS.length - 1 && (
          <div className={`flex-1 h-0.5 -mt-[22px] ${step.done ? 'bg-brand-500' : 'bg-gray-200'}`} />
        )}
      </Fragment>
    ))}
  </div>
);

export default MotifSteps;
